import axios from "axios";
import { BASE_URL } from "../../keys";

const apiPost = (url: string, body: object, options: object = {}) => {
  const finalUrl: string = BASE_URL + url;
  return new Promise<any>((resolve, reject) => {
    axios
      .post(finalUrl, body, {
        ...options,
        withCredentials: false,
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(
          new Error(
            error.error || error.response?.data?.message || error.message
          )
        );
      });
  });
};

const apiGet = (url: string, options: object = {}) => {
  const finalUrl: string = BASE_URL + url;
  return new Promise<any>((resolve, reject) => {
    axios
      .get(finalUrl, {
        ...options,
        withCredentials: false,
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(
          new Error(
            error.error || error.response?.data?.message || error.message
          )
        );
      });
  });
};

const apiDelete = (url: string, options: object = {}) => {
  const finalUrl: string = BASE_URL + url;
  return new Promise<any>((resolve, reject) => {
    axios
      .delete(finalUrl, {
        ...options,
        withCredentials: false,
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(
          new Error(
            error.error || error.response?.data?.message || error.message
          )
        );
      });
  });
};

const apiDeleteWithBody = (
  url: string,
  body: object = {},
  options: object = {}
) => {
  const finalUrl: string = BASE_URL + url;
  return new Promise<any>((resolve, reject) => {
    axios({
      method: "DELETE",
      url: finalUrl,
      data: body,
      withCredentials: false,
      ...options,
    })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(
          new Error(
            error.error || error.response?.data?.message || error.message
          )
        );
      });
  });
};

const apiPut = (url: string, body: object, options: object = {}) => {
  const finalUrl: string = BASE_URL + url;
  return new Promise<any>((resolve, reject) => {
    axios
      .put(finalUrl, body, {
        ...options,
        withCredentials: false,
      })
      .then((response) => resolve(response))
      .catch((error) => {
        reject(
          new Error(
            error.error || error.response?.data?.message || error.message
          )
        );
      });
  });
};

const setGlobalHeader = (headerName: string, value: string): void => {
  axios.defaults.headers[headerName] = value;
};

const resetGlobalHeader = (headerName: string): void => {
  axios.defaults.headers[headerName] = "";
};

export {
  apiPost,
  apiGet,
  apiPut,
  apiDelete,
  apiDeleteWithBody,
  setGlobalHeader,
  resetGlobalHeader,
};
